import { SVGProps } from 'react';

export const RefreshIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.888 4.52867C11.8007 3 10.0187 2 8 2C4.686 2 2 4.686 2 8C2 8.35933 2.03733 8.70933 2.098 9.05067"
        stroke="#323232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2.94922 13.0628V11.4714H4.54189" stroke="#323232" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M3.11182 11.4712C4.19915 12.9999 5.98115 13.9999 7.99982 13.9999C11.3138 13.9999 13.9998 11.3139 13.9998 7.99989C13.9998 7.64055 13.9625 7.29055 13.9018 6.94922"
        stroke="#323232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.0507 2.93726V4.52859H11.458" stroke="#323232" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
